// Opens the app-wide Messages modal (MessagingHost) from anywhere — e.g. a
// task link's card in a note — and tells the Navbar when it closes so its
// unread badge refreshes.
export const OPEN_MESSAGES = "notesai:open-messages";
export const MESSAGES_CLOSED = "notesai:messages-closed";

// detail: { tab?: "chat" | "tasks", focus?: { kind: "task" | "order" | "agent" | "channel", id } }
// A "task" or "order" focus goes with the Tasks tab (the row to focus); an
// "agent" focus with Chat (the agent's own thread, by the agent's id); a
// "channel" focus with Chat too (that conversation, by its id: a desktop
// notification's click, utils/messagingNotifications.js).
export function openMessages(detail = {}) {
  window.dispatchEvent(new CustomEvent(OPEN_MESSAGES, { detail }));
}

export function onOpenMessages(cb) {
  const handler = (e) => cb(e.detail || {});
  window.addEventListener(OPEN_MESSAGES, handler);
  return () => window.removeEventListener(OPEN_MESSAGES, handler);
}

export function emitMessagesClosed() {
  window.dispatchEvent(new CustomEvent(MESSAGES_CLOSED));
}

export function onMessagesClosed(cb) {
  window.addEventListener(MESSAGES_CLOSED, cb);
  return () => window.removeEventListener(MESSAGES_CLOSED, cb);
}

export const CLOSE_MESSAGES = "notesai:close-messages";

// Closes the Messages modal — e.g. a task's "Open in chart" leaving for a chart.
export function closeMessages() {
  window.dispatchEvent(new CustomEvent(CLOSE_MESSAGES));
}

export function onCloseMessages(cb) {
  window.addEventListener(CLOSE_MESSAGES, cb);
  return () => window.removeEventListener(CLOSE_MESSAGES, cb);
}
